<div class="row">
    <div class="container">
        <div class="col-md-12" class="fs16">
            <div class="card">
                <div class="card-header">
                    <i style="margin-left: 1%;" class="material-icons">person</i>
                    <h1 style="text-align: center; margin-left: 1%;">{{user.user}}</h1>
                </div>
                <div class="card-body flexChildren">
                    <div>
                        <p><b>{{'USER_DETAIL.NAME' |translate}}</b></p> <p class="ml1medio">{{user.name}}</p>
                    </div>
                    <hr />
                    <div>
                        <p><b>{{'USER_DETAIL.FIRSTNAME' |translate}}</b></p> <p class="ml1medio">{{user.firstName}}</p>
                    </div>
                    <hr />
                    <div>
                        <p><b>{{'USER_DETAIL.EMAIL' |translate}}</b></p> <p class="ml1medio">{{user.email}}</p>
                    </div>
                    <hr />
                    <div>
                        <p><b>{{'USER_DETAIL.STATE' |translate}}</b></p> <p class="ml1medio">{{user.state}}</p>
                        <mat-icon  [ngClass]="{'activado': user.state === 'Activado', 'desactivado' : user.state === 'Desactivado' }">
                            circle
                        </mat-icon>
                    </div>
                    <hr />
                    <p><b>{{'USER_DETAIL.ROL' |translate}}</b></p> 
                    <ng-container>
                        <ul *ngFor="let rol of user.rol">
                            <li *ngIf="rol!='admin'">
                                {{"USER_FORM.ROLES.".concat(rol) | translate}}
                            </li>
                        </ul>
                    </ng-container>
                    <hr />
                    <div>
                        <p><b>{{'USER_DETAIL.TIMEZONE' |translate}}</b></p> <p class="ml1medio">{{user.timeZone | NullFormat}}</p>
                    </div>
                    <hr />
                    <div>
                        <p><b>{{'USER_DETAIL.LANGUAGE' |translate}}</b></p> <p class="ml1medio">{{user.language | NullFormat}}</p>
                    </div>
                    <hr />
                    <p><b>{{'USER_DETAIL.FACTORIES' |translate}}</b></p>
                    <ul>
                        <li *ngFor="let factory of user.factories">{{factory.name}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
